import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { AdminVendorStatsState } from "../../models/mp-admin/vendor-stats-state";

const initialState: AdminVendorStatsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.vendorStats.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.vendorStats.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function vendorStatsReducer(
	state: AdminVendorStatsState | undefined,
	action: Action
): AdminVendorStatsState {
	return reducer(state, action);
}
